export default "__VITE_ASSET__CeICeQOJ__"